import { render, staticRenderFns } from "./black_list.vue?vue&type=template&id=d5f94fa0&scoped=true"
import script from "./black_list.vue?vue&type=script&lang=ts"
export * from "./black_list.vue?vue&type=script&lang=ts"
import style0 from "./black_list.vue?vue&type=style&index=0&id=d5f94fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f94fa0",
  null
  
)

export default component.exports